import { Icon24AspectRatio } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import { LinkBreakIcon } from './LinkBreakIcon';

export const AspectRatioIcon = fplIcon(LinkBreakIcon, Icon24AspectRatio);
